/**
 * Created by claudio iozzia on 03/07/2017.
 */
import {Validator_Common} from "../../../../models/validator/validator_common";
import {Ic, IEntityAlert} from "../../../../models/common";
import {Utils} from "../../../../common/utils";
import {EntityError} from "../../../../models/EntityAlert";
import {IAppSpec} from "../../../../Redux/selector.state";
import {ValidatorOutputFn} from "../../../../models/validator/IValidator";
import {calculate_voutUpperBound} from "./dcdc__common_validator";

export class Validator_DcDc_Buck extends Validator_Common {

  private validatorFn_SingleOutput_Voltage_Buck: ValidatorOutputFn = (a: Ic, spec: IAppSpec, o: number): IEntityAlert => {
    const _vInMin = spec.spec.value.input.min;
    const _vOut = spec.spec.value.output.outputs[o].voltage;
    if (a.vouts) { // Added to manage Vout array accepted values
      const vOutsFiltered = a.vouts.filter(vout => vout <= _vInMin);
      return new EntityError(Utils.acceptInArray(_vOut, vOutsFiltered.length > 0 ? vOutsFiltered : a.vouts, "Vout", "V"));
    } else {
      const vOutUpperBound = calculate_voutUpperBound(a, spec);
      return new EntityError(Utils.acceptInRange(_vOut, a.vout_min, vOutUpperBound, "Vout", "V"));
    }
  }

  private validatorFn_SingleOutput_Current_Buck: ValidatorOutputFn = (a: Ic, spec: IAppSpec, o: number): IEntityAlert => {
    const _iOut = spec.spec.value.output.outputs[o].current;

    const result = Utils.acceptUpTo(_iOut, a.iout_max, "Iout", "A");
    return new EntityError(result);
  }


  protected singleOutputV(): ValidatorOutputFn[] {
    return [this.validatorFn_SingleOutput_Voltage_Buck].concat(super.singleOutputV());
  }

  protected singleOutputI(): ValidatorOutputFn[] {
    return [this.validatorFn_SingleOutput_Current_Buck].concat(super.singleOutputI());
  }

}
